const ApiBaseUrl = "https://api.madadgaar.com.pk/api";

export default ApiBaseUrl;